<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<span epub:type="pagebreak" id="pagei" title="i"></span><a href="#/Text/Contents#title"><img alt="" src="Images/Titlepage.jpg"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?09be7859